module.exports = __webpack_public_path__ + "static/media/BOOK_OFF.4f416c05.svg";